module.exports = __webpack_public_path__ + "img/ab-page4-js.80105da0.png";